import { useEffect, useRef } from 'react'

// Composer drafts survive navigation/refresh via localStorage. Keyed per
// ticket (`<ticketId>`) plus a `new` key for the create form. Body text only —
// attachments are already uploaded server-side and aren't worth persisting.
const PREFIX = 'helpdesk:draft:'

export function loadDraft(key: string): string {
  try {
    return window.localStorage.getItem(PREFIX + key) ?? ''
  } catch {
    return ''
  }
}

export function clearDraft(key: string) {
  try {
    window.localStorage.removeItem(PREFIX + key)
  } catch {
    /* private mode / quota — drafts are best-effort */
  }
}

/** Debounced persist: writes `value` 300ms after the last change; empty clears. */
export function useDraftPersist(key: string, value: string) {
  const timer = useRef<number | undefined>(undefined)
  useEffect(() => {
    window.clearTimeout(timer.current)
    timer.current = window.setTimeout(() => {
      try {
        if (value.trim()) window.localStorage.setItem(PREFIX + key, value)
        else window.localStorage.removeItem(PREFIX + key)
      } catch {
        /* best-effort */
      }
    }, 300)
    return () => window.clearTimeout(timer.current)
  }, [key, value])
}
